"use client";

import { AppBar, Box, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import FilterConfigurationBox from "@/app/(user)/koleksi/FilterConfigurationBox";
import { Dispatch, SetStateAction } from "react";

export interface FilterDialogProps {
  open: boolean;
  onClose: (value: object) => void;
  buttonIsActive: { relevan: boolean; terbaru: boolean; banyakDibaca: boolean };
  setButtonIsActive: Dispatch<SetStateAction<{ relevan: boolean; terbaru: boolean; banyakDibaca: boolean }>>;
  jenis_pustaka: { id: string; label: string }[];
  jenisPustakaSelected: { id: string; label: string };
  setJenisPustakaSelected: (value: { id: string; label: string }) => void;
  klasifikasiSelected: string[];
  setKlasifikasiSelected: (value: string[]) => void;
  klasifikasiList: { id: string; nama: string }[] | null;
  setKlasifikasiList: (value: { id: string; nama: string }[] | null) => void;
  rangeTahun: [number, number];
  setRangeTahun: (value: [number, number]) => void;
}

export default function FilterKoleksiDialog(props: FilterDialogProps) {
  const {
    open,
    onClose,
    buttonIsActive,
    setButtonIsActive,
    jenis_pustaka: jenisPustaka,
    jenisPustakaSelected,
    setJenisPustakaSelected,
    klasifikasiSelected,
    setKlasifikasiSelected,
    klasifikasiList,
    setKlasifikasiList,
    rangeTahun,
    setRangeTahun
  } = props;

  const handleClose = () => {
    onClose({});
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ flex: 1 }} variant="h6" component="div">
            Filter
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ padding: 2 }}>
        <FilterConfigurationBox
          buttonIsActive={buttonIsActive}
          setButtonIsActive={setButtonIsActive}
          jenisPustaka={jenisPustaka}
          jenisPustakaSelected={jenisPustakaSelected}
          setJenisPustakaSelected={setJenisPustakaSelected}
          klasifikasiSelected={klasifikasiSelected}
          setKlasifikasiSelected={setKlasifikasiSelected}
          klasifikasiList={klasifikasiList}
          setKlasifikasiList={setKlasifikasiList}
          rangeTahun={rangeTahun}
          setRangeTahun={setRangeTahun}
        />
      </Box>
    </Dialog>
  );
}